import type { InputType } from 'config'

export const giftsOrGrantsColumnKeys = ['assetType', 'depositedStatus', 'source', 'cashOrMarketValue'] as const

export const giftsOrGrantsColumnHeaders: Record<string, string> = {
  assetType: 'Asset Type',
  depositedStatus: 'Status',
  source: 'Source',
  cashOrMarketValue: 'Value',
}

const sourceOptions = [
  'Community Nonprofit',
  'Employer',
  'Federal Agency',
  'Lender',
  'Local Agency',
  'Non-originating Lender',
  'Other',
  'Parent',
  'Relative',
  'Religious Nonprofit',
  'State Agency',
  'Unnamed Partner',
  'Unrelated Friend',
  'Non-Parent Relative (obsolete)',
]

export const giftsOrGrantsInputs: Record<string, InputType> = {
  held: {
    title: 'Held',
    inputType: 'select',
    hasDefaultOption: true,
    options: ['Jointly', 'Individually'],
    value: '',
    error: '',
  },
  assetType: {
    title: 'Asset Type',
    inputType: 'select',
    hasDefaultOption: true,
    options: ['Cash Gift', 'Gift of Equity', 'Grant'],
    value: '',
    error: '',
    required: true,
  },
  depositedStatus: {
    title: 'Deposited Status',
    inputType: 'select',
    hasDefaultOption: true,
    options: ['Deposited', 'Not Deposited'],
    value: '',
    error: '',
  },
  source: {
    title: 'Source',
    inputType: 'select',
    hasDefaultOption: true,
    options: sourceOptions,
    value: '',
    error: '',
  },
  cashOrMarketValue: {
    title: 'Cash or Market Value',
    inputType: 'text',
    type: 'thousandSep',
    prefix: '$',
    value: '',
    error: '',
  },
  relationshipToBorrower: {
    title: 'Relationship to Borrower',
    inputType: 'text',
    value: '',
    error: '',
  },
  donorName1: {
    title: 'Donor Name 1',
    inputType: 'text',
    value: '',
    error: '',
  },
  donorName2: {
    title: 'Donor Name 2',
    inputType: 'text',
    value: '',
    error: '',
  },
  donorAddress: {
    title: 'Donor Street, City, State, Zip',
    inputType: 'map',
    value: '',
    error: '',
  },
  donorPhone: {
    title: 'Donor Phone',
    inputType: 'text',
    type: 'phone',
    value: '',
    error: '',
  },
  institutionName: {
    title: "Institution Name (Donor's Account)",
    inputType: 'text',
    value: '',
    error: '',
  },
  institutionAddress: {
    title: 'Institution Address',
    inputType: 'text',
    value: '',
    error: '',
  },
  accountNo: {
    title: 'Account No',
    inputType: 'text',
    value: '',
    error: '',
  },
  fundsProvidedAtClosing: {
    title: 'Funds Provided at Closing',
    inputType: 'select',
    hasDefaultOption: true,
    options: ['Yes', 'No'],
    value: '',
    error: '',
  },
  transferDate: {
    title: 'Transfer Date',
    inputType: 'text',
    type: 'date',
    value: '',
    error: '',
  },
}
